export const canvas = () => {
    
    const canvas = document.querySelector("canvas")

    if (canvas) {

        // canvas settings
        const context = canvas.getContext("2d")
        canvas.width = 1000
        canvas.height = 560

        // paths of images
        const imageList = [
            "/wp-content/themes/engineers/assets/images/test-logo/1.png",
            "/wp-content/themes/engineers/assets/images/test-logo/2.png",
            "/wp-content/themes/engineers/assets/images/test-logo/3.png",
            "/wp-content/themes/engineers/assets/images/test-logo/4.png",
            "/wp-content/themes/engineers/assets/images/test-logo/5.png",
            "/wp-content/themes/engineers/assets/images/test-logo/6.png",
            "/wp-content/themes/engineers/assets/images/test-logo/7.png",
            "/wp-content/themes/engineers/assets/images/test-logo/8.png",
            "/wp-content/themes/engineers/assets/images/test-logo/9.png",
            "/wp-content/themes/engineers/assets/images/test-logo/10.png",
            "/wp-content/themes/engineers/assets/images/test-logo/11.png",
            "/wp-content/themes/engineers/assets/images/test-logo/12.png",
            "/wp-content/themes/engineers/assets/images/test-logo/13.png",
            "/wp-content/themes/engineers/assets/images/test-logo/14.png",
            "/wp-content/themes/engineers/assets/images/test-logo/15.png",
            "/wp-content/themes/engineers/assets/images/test-logo/16.png",
            "/wp-content/themes/engineers/assets/images/test-logo/17.png",
            "/wp-content/themes/engineers/assets/images/test-logo/18.png",
            "/wp-content/themes/engineers/assets/images/test-logo/19.png",
            "/wp-content/themes/engineers/assets/images/test-logo/20.png",
            "/wp-content/themes/engineers/assets/images/test-logo/21.png",
            "/wp-content/themes/engineers/assets/images/test-logo/22.png",
            "/wp-content/themes/engineers/assets/images/test-logo/23.png",
            "/wp-content/themes/engineers/assets/images/test-logo/24.png",
            "/wp-content/themes/engineers/assets/images/test-logo/25.png",
            "/wp-content/themes/engineers/assets/images/test-logo/26.png",
            "/wp-content/themes/engineers/assets/images/test-logo/27.png",
            "/wp-content/themes/engineers/assets/images/test-logo/28.png",
            "/wp-content/themes/engineers/assets/images/test-logo/29.png",
            "/wp-content/themes/engineers/assets/images/test-logo/30.png"
        ]        

        // create the new image element and load 
        function preloadImages(i) {  
            return new Promise((res) => { 
                const image = new Image()
                image.src = imageList[i]
                image.onload = () => res(image)
            })
        }  

        // loaded images list
        let imageLoadList = []

        async function updateImageLoadList() {        
            for (let i = 0; i < imageList.length; i++) {
                imageLoadList.push(await preloadImages(i))
            }        
        }

        updateImageLoadList()

        // animation settings
        const framesCount = 30
        const scrollingHeight = 2000
        
        // change the frame and draws on the page
        function changeFrame(scrollY) {
            let frame = parseInt(scrollY / (scrollingHeight / framesCount) + 1)
            frame = frame > framesCount ? framesCount : frame        
            const image = imageLoadList[frame]
            context.drawImage(image, 0, 0 , canvas.width, canvas.height)
        }

        // change the frame after scrolling
        document.addEventListener("scroll", () => {
            if (window.scrollY < 2000) {
                changeFrame(window.scrollY)
                console.log(window.scrollY)
            }        
        })

        
        //добавить фрейм при загрузке страницы

    }
}